import script from "./LeadBySocialMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadBySocialMedia.vue?vue&type=script&setup=true&lang=js"

import "./LeadBySocialMedia.vue?vue&type=style&index=0&id=223a2bc2&scoped=true&lang=css"

import exportComponent from "/builds/izee/leadservice/lead-admin-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-223a2bc2"]])

export default __exports__